import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Weight } from "lucide-react";
import { Control } from "react-hook-form";
import { FormData } from "./schema";

interface WeightCardProps {
  control: Control<FormData>;
}

export function BolCard({ control }: WeightCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Weight className="h-4 w-4" />
          Bol Number
        </CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <FormField
          control={control}
          name="bol"
          render={({ field }) => (
            <FormItem>
              <FormLabel>BOL</FormLabel>
              <FormControl>
                <Input
                  value={field.value ?? ""}
                  placeholder="Enter BOL number"
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
